import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#EBEBEB] bg-[#F7F7F9] mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <img src="/ixitrip-wordmark.png" alt="ixitrip — travel simplified" className="h-11 w-auto mb-3" />
          <p className="text-sm text-[#717171] leading-relaxed">
            The first commission-free OTA — more revenue for hotels, cheaper prices for travelers.
          </p>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3 text-sm">For Travelers</h4>
          <ul className="space-y-2 text-sm text-[#717171]">
            <li><Link to="/search" className="hover:text-[#FF385C]">Search stays</Link></li>
            <li><Link to="/bookings" className="hover:text-[#FF385C]">My bookings</Link></li>
            <li><Link to="/cancellation-policy" className="hover:text-[#FF385C]">Cancellation policy</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3 text-sm">For Hosts</h4>
          <ul className="space-y-2 text-sm text-[#717171]">
            <li><Link to="/host/properties" className="hover:text-[#FF385C]">List your property</Link></li>
            <li><Link to="/host" className="hover:text-[#FF385C]">Host dashboard</Link></li>
            <li><Link to="/services" className="hover:text-[#FF385C]">Travel add-ons</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3 text-sm">Company</h4>
          <ul className="space-y-2 text-sm text-[#717171]">
            <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#FF385C]">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[#FF385C]">Privacy Policy</Link></li>
            <li><Link to="/cancellation-policy" data-testid="footer-cancellation-link" className="hover:text-[#FF385C]">Cancellation Policy</Link></li>
            <li><a href="mailto:customerservice@ixitrip.com" data-testid="footer-contact-link" className="hover:text-[#FF385C]">Contact us</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#EBEBEB] py-6 text-center text-xs text-[#717171]">
        © {new Date().getFullYear()} Ixitrip. Built for a fairer travel ecosystem.
      </div>
    </footer>
  );
}
